import { render, staticRenderFns } from "./ScreenNamePrinter.vue?vue&type=template&id=712d2b26&scoped=true&"
import script from "./ScreenNamePrinter.vue?vue&type=script&lang=ts&"
export * from "./ScreenNamePrinter.vue?vue&type=script&lang=ts&"
import style0 from "./ScreenNamePrinter.vue?vue&type=style&index=0&id=712d2b26&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "712d2b26",
  null
  
)

export default component.exports